import { FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormAdapter } from '@form/cer-form-adapter';

import { CerFormView } from '@form/cer-form-view';


export class DocumentLibUserForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet) {
    const user = DocumentLibUserForm.viewUserGet()
    viewSet.viewAdd(user);
  }

  public static viewUserGet(): CerFormView {
    var viewDoc = new CerFormView();
    viewDoc.viewMetadata = {
      dataApiName: 'DocumentLibUser', primaryKey: 'id', titleFields: ['name'], baseFields: ['id', 'history']
    };
    viewDoc.fieldMetadata = [
      { fieldType: 'documentLib', required: true, widthType: FieldWidthEnum.M },
      { fieldType: 'user', widthType: FieldWidthEnum.M },
      { fieldType: 'role', widthType: FieldWidthEnum.M },
      { fieldType: 'active', defaultValue: true },
      { name: 'allowEdit', text: "Tillad rediger?", format: 'CheckBox', defaultValue: false },
      { name: 'allowCreate', text: "Tillad tilføj?", format: 'CheckBox', defaultValue: false },
      { name: 'allowDelete', text: "Tillad slet?", format: 'CheckBox', defaultValue: false },
      { name: 'indirectAccess', text: "Skjul navigering?", format: 'CheckBox', defaultValue: false }
    ];
    return viewDoc;
  }
}
